<div class="page-header flex flex-row px-4 py-2 gap-2">
  <div class="flex-1 bm-breadcrumbs text-sm">
    <ul class="m-0 p-0">
      <li>
        <a [routerLink]="'/'">Home</a>
      </li>
      <li>
        <a [routerLink]="'/lager'"> <i class="fa fa-building-o"></i> Lager </a>
      </li>
      <li>
        <a> Übersicht </a>
      </li>
    </ul>
  </div>

  <a [routerLink]="'/lager/neu'" class="bm-join-item bm-btn">
    <i class="fa fa-plus"></i> Neues Lager
  </a>

  <input type="text" class="bm-input" (input)="quicksearchChanged($event)" placeholder="Schnellfilter" />
</div>
<div class="page-content page-frame">
  <ag-grid-angular
    class="ag-theme-quartz h-full shadow"
    [theme]="hawkTheme"
    [loadThemeGoogleFonts]="true"
    [defaultColDef]="defaultColDef"
    [columnDefs]="colDefs"
    [rowClassRules]="rowClassRules"
    [pagination]="true"
    [rowData]="warehouses"
    [rowSelection]="rowSelection"
    [initialState]="initialState"
    [paginationPageSize]="paginationPageSize"
    [localeText]="locale"
    [sideBar]="sideBarOptions"
    [paginationPageSizeSelector]="paginationPageSizeSelector"
    (gridReady)="onGridReady($event)"
  />
</div>
